import { jsx as _jsx } from "react/jsx-runtime";
import { ServiceChannels } from "../../components/ServiceChannels";
var Home = function () { return _jsx(ServiceChannels, {}); };
export default Home;
